import { BSLInit, BSLAppInterface } from './core';
var bslUserId = '';

// function GetCore() {
//   return appData.GetApp();
// }

// function GetAppData() {
//   return appData;
// }

// function DeleteCore() {
//   if (appData) appData.Uninit();
//   appData = null;
// }

// function AuthChanged(params) {
//   if (params.userId != bslUserId) {
//     bslModules = {};
//   }

//   bslUserId = params.userId;
// }

export {
  BSLAppInterface, // bsl初始化时需要初始化的类
  BSLInit, // bsl初始化
  // SetCore,
  // GetCore,
  // DeleteCore,
  // AuthChanged,
  // GetAppData
};
